<template>
  <div class="flex flex-wrap justify-between lg:justify-end">
    <div class="flex w-full items-center py-2 md:w-auto">
      <a @click="$router.push('/print-order-form')" class="flex items-center cursor-pointer py-2 hover:text-print-order-teal" :class="$route.name === 'PrintOrderForm' ? 'border-b-2 border-print-order-teal text-print-order-teal' : ''">
        <i class="fas fa-plus mr-2 text-lg" :class="$route.name === 'PrintOrderForm' ? 'text-print-order-teal' : 'text-grey'" /> <span class="text-sm">Order Products</span>
      </a>
    </div>
    <div class="flex w-full items-center py-2 md:w-auto md:ml-10">
      <a @click="$router.push('/print-order-form/order-history')" class="flex items-center relative cursor-pointer py-2 hover:text-print-order-teal" :class="$route.name === 'PrintOrderHistory' ? 'border-b-2 border-print-order-teal text-print-order-teal' : ''">
        <i class="fas fa-list mr-2 text-lg" :class="$route.name === 'PrintOrderHistory' ? 'text-print-order-teal' : 'text-grey'" /> <span class="text-sm">Order History</span>
        <span v-if="pendingCount && pendingCount > 0" class="absolute text-center text-xxs rounded-full bg-grey-dark text-white h-4 w-4 shadow" style="top: -8px; right: -18px; line-height: 16px;">{{ pendingCount > 99 ? '99+' : pendingCount }}</span>
      </a>
    </div>
    <div class="flex w-full items-center py-2 md:w-auto md:ml-10">
      <a @click="$router.push('/print-order-form/saved-items')" class="flex items-center relative cursor-pointer py-2 hover:text-print-order-teal" :class="$route.name === 'PrintOrderSavedItems' ? 'border-b-2 border-print-order-teal text-print-order-teal' : ''">
        <i class="far fa-bookmark mr-2 text-lg text-grey" :class="$route.name === 'PrintOrderSavedItems' ? 'text-print-order-teal' : 'text-grey'" /> <span class="text-sm">Saved Items</span>
        <span v-if="savedCount && savedCount > 0" class="absolute text-center text-xxs rounded-full bg-grey-dark text-white h-4 w-4 shadow" style="top: -8px; right: -18px; line-height: 16px;">{{ savedCount > 99 ? '99+' : savedCount }}</span>
      </a>
    </div>
    <div class="flex w-full items-center mt-3 mb-4 md:w-auto md:my-0 md:ml-10">
      <a @click="$router.push('/print-order-form/basket')" class="flex items-center border border-print-order-teal rounded-lg bg-grey-lightest hover:bg-teal-lightest hover:text-print-order-teal cursor-pointer px-8 py-3" :class="$route.name === 'PrintOrderBasket' ? 'bg-print-order-teal text-white' : ''">
        <span class="relative">
          <span class="text-sm leading-normal">Basket</span> <i class="fas fa-shopping-cart ml-2 text-lg opacity-50" />
          <span v-if="basketCount && basketCount > 0" class="absolute text-center text-xxs rounded-full text-white h-4 w-4 shadow" style="top: -8px; right: -18px; line-height: 16px;" :class="$route.name === 'PrintOrderBasket' ? 'bg-print-order-teal-dark' : 'bg-print-order-teal'">{{ basketCount > 99 ? '99+' : basketCount }}</span>
        </span>
      </a>
    </div>
  </div>
</template>

<script>
import { v2Api } from '@/http'
import { mapState } from 'vuex'

export default {
  name: 'PrintSubMenu',
  data () {
    return {
      pendingCount: null,
      savedCount: null,
      basketCount: null
    }
  },
  computed: {
    ...mapState(['selectedOffice'])
  },
  created () {
    this.loadBadgeCounts()
  },
  methods: {
    loadBadgeCounts () {
      return v2Api.get('custom-print-order-items/badge-counts', {
        params: {
          office_id: this.selectedOffice.id
        }
      }).then((response) => {
        this.pendingCount = response.data.pending
        this.savedCount = response.data.saved
        this.basketCount = response.data.basket
      })
    }
  }
}
</script>
